import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { SignatureParticipantStatusEnum, participantStatusTextMap } from './../../models/signature-request.dict';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSlash, faCircleXmark, faCircleCheck, faPencil, faClock } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'signature-participant-status-badge',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './signature-participant-status-badge.component.html',
  styleUrls: ['./signature-participant-status-badge.component.scss']
})
export class SignatureParticipantStatusBadgeComponent implements OnInit, OnChanges{
  public statusText: string = '';
  @Input() status!: SignatureParticipantStatusEnum;
  @Input() showIcon: boolean = true;

  faSlash = faSlash;
  faCircleXmark = faCircleXmark;
  faCircleCheck = faCircleCheck;
  faPencil = faPencil;
  faClock = faClock;


  ngOnInit() {
    this.statusText = participantStatusTextMap[this.status] || '';
  }
  ngOnChanges() {
    this.statusText = participantStatusTextMap[this.status] || '';
  }
}
